import React from "react";
import "./EmbedDialog.scss";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import i18n from "i18next";

import { handSlug } from "../../api/ReplayVariables";

function EmbedDialog({ show, handleClose, hand }) {
  const { t } = useTranslation();

  const code =
    window.location.protocol + "//" + window.location.hostname+"/opencards/" +
    i18n.language +
    "/e/" +
    handSlug(hand);
  const testCode = "/opencards/" + i18n.language + "/ea/" + handSlug(hand);
  const embedCode =
    '<iframe title="Xeester Replayer" width="560" height="315" sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms" src="' +
    code +
    '" frameborder="0" allowfullscreen></iframe>';

  const copied = () => {
    console.log("copied");
    toast.dark(t("replayApp.share.codeCopied"), {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: 0
    });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop
      keyboard={false}
      centered
      dialogClassName="embed-dialog"
    >
      <Modal.Header closeButton  closeLabel={false}>
        <Modal.Title>{t("replayApp.share.embed")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PerfectScrollbar>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Control
              as="textarea"
              readOnly
              defaultValue={embedCode}
              rows="5"
            ></Form.Control>
          </Form.Group>
          <div className="replayer-container">
            <iframe
              className="_replayer"
              title="Xeester Replayer"
              src={testCode}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </PerfectScrollbar>
      </Modal.Body>
      <Modal.Footer>
        <CopyToClipboard text={embedCode}>
          <Button onClick={copied}>{t("replayApp.share.copyCode")}</Button>
        </CopyToClipboard>
      </Modal.Footer>
    </Modal>
  );
}

export default EmbedDialog;
